import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles(theme => ({
  section: {
    marginBottom: theme.spacing(2),
  },
  sectionTitle: {
    fontWeight: 600,
    marginBottom: theme.spacing(1),
  },
  row: {
    display: 'flex',
    marginBottom: theme.spacing(0.5),
    borderRadius: theme.shape.borderRadius,
    padding: theme.spacing(0.5, 1),
    marginLeft: -theme.spacing(1),
    marginRight: -theme.spacing(1),
    transition: 'background-color 0.15s ease',
    '&:hover': {
      backgroundColor: theme.palette.action.hover,
    },
  },
  label: {
    fontWeight: 600,
    width: 150,
    flexShrink: 0,
    color: theme.palette.text.secondary,
  },
  value: {
    color: theme.palette.text.primary,
  },
  assetList: {
    paddingLeft: theme.spacing(2),
    margin: 0,
  },
}));

export default useStyles;
